export default "__VITE_ASSET__5ed9ea93__"